module.exports = __webpack_public_path__ + "assets/img/18_1874_big.5d588dd5.jpg";